<template>
  <wizard-summary-option
    v-if="wizard.askRegion && wizard.sceltaLocationDeploy"
    :name="$t('Location principale')"
    :value="wizard.locations[wizard.sceltaLocationDeploy]"
    edit-step="WizardStepLocation"
    ouia-id="wizard-summary-location-deploy"
  />
  <wizard-summary-option
    v-if="wizard.askRegion && wizard.askRegionBackup && wizard.sceltaLocationBackup && !hideBackup"
    :name="$t('Location backup')"
    :value="wizard.locations[wizard.sceltaLocationBackup]"
    edit-step="WizardStepLocation"
    ouia-id="wizard-summary-location-backup"
  />
</template>

<script lang="ts" setup>
import WizardSummaryOption from './wizard-summary-option.vue';
import { useWizard } from '@/wizard';

const wizard = useWizard();

defineProps<{
  hideBackup?: boolean;
}>();
</script>
